export default{

    isOk: false,
    error:null,
    errorMessage:'',
    tickets:'',
    ticket:'',
    images:'',
    activity:'',
    total:0,
    abiertos:0,
    cerrados:0,
    
    
    
}